import s from './InChatView.module.css';
import '../styles.css';
import ChatMessage, { MessageTextView } from "@common/Chat/components/ChatMessage/ChatMessage";
import React, {useEffect, useRef, useState} from "react";
import {chatApi} from "@/api";
import sendIcon from '../icons/3682321.png'
import {
    ArrowLeftIcon, ClipIcon,
    CloseIcon,
    DotsIcon,
    PaperClipIcon
} from "@/utils/icons";
import classNames from "classnames";
import {useSelector} from "react-redux";
import {selectProfile} from "@store/profile.reducer";
import {CollapseBtn} from '@UI/Button'
import {useInputNew} from "@UI/InputNew/useInputNew";
import * as InputNew from "@UI/InputNew/Input";
import InputEmoji from 'react-input-emoji'
import {getRightWord} from "@common/Chat/helpers";
import { useChatContext } from '../ChatContext';
import Moment from "react-moment";
import Popup from "@common/Chat/components/Popup/Popup";
import FixedMessage from "@common/Chat/components/ChatMessage/FixedMessage";
import UserImage from "@common/Chat/components/UserImage/UserImage";
import axios from "axios";
import moment from "moment";
import chatView from "@common/Chat/components/ChatView/ChatView";
import {isJson} from '@/helpers/isJson';
import {containsHtmlTags} from '@/utils/RegexUtils/regexMatch';
import { createDate } from '@/helpers/date';
import websocket from '@/utils/websocket';
import useIsTechSupport from '../SupportChatButton/useIsTechSupport';
import EditEntityModal from '@modals/EditEntityModal/EditEntityModal';
import { useGetDataForEditEntityModal } from '@modals/EditEntityModal/hooks/useGetDataForEditEntityModal';

const InChatView = ({setPage, chat, activeUsers, height}) => {
    const [editChildren, setEditChildren] = useState(null);
    const profile = useSelector(selectProfile);
    const chatContext = useChatContext();
    const [action, setAction] = useState('')
    const [isVisiblePopup, setIsVisiblePopup] = useState(false);
    const [data, setData] = useState(null);
    const [message, setMessage] = useState('');
    const [isActive, setIsActive] = useState(false);
    const [answerTo, setAnswerTo] = useState(null);
    const [answerAuthor, setAnswerAuthor] = useState(null)
    const messageEndRef = useRef(null)
    const [file, setFile] = useState(null);
    const [isNeedUpdate, setIsNeedUpdate] = useState(false);
    const [saving, setSaving] = useState(false);
    const [progress, setProgress] = useState(0);
    const titleChat = data?.members?.length === 2 ? (data?.members.find(member => member.name !== profile.name))?.name : data?.name;
    const idInterlocutor = data?.type === 'support' ? (data?.members.find(member => member?.isCreator === 1))?.user_id : null;
    const fixedRef = useRef(null);
    const chatsListRef = useRef(null);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const { dataForEditEntityModal } = useGetDataForEditEntityModal({priorities: ['student', 'parent', 'employee'], userId: editChildren})
    // Функция для сброса счетчика поддержки при чтении сообщений в чате поддержки
    const resetSupportUnreadCountIfNeeded = () => {
        if (data?.type === 'support' && chatContext) {
            chatContext.setUnreadSupportMessagesCount(0);
        }
    }

    useEffect(() => {
        chatApi.getChat(chat).then((res) => {
            setData(res?.data)
            setIsNeedUpdate(false)
            // Сбрасываем счетчик поддержки при загрузке чата поддержки
            if (res?.data?.type === 'support' && chatContext) {
                chatContext.setUnreadSupportMessagesCount(0);
            }
        })
    }, [isNeedUpdate]);

    useEffect(() => {
        websocket.send('join_chat', { chatId: chat, origin: window.location.origin });

        websocket.subscribe('chat_message', (newMessage) => {
            if (newMessage) {
                const originUrl = new URL(newMessage.message.origin);
                const originDomain = originUrl.hostname

                if (originDomain !== window.location.hostname) return

                setData(prevData => ({
                    ...prevData,
                    messages: [...prevData.messages, newMessage.message]
                }));

                chatApi.readAllChatMessages(chat).then(() => {
                    scrollToBottom();
                    resetSupportUnreadCountIfNeeded();
                });
            }
        });

        websocket.subscribe('file_uploaded', (fileData) => {
            // FIXME: добавить проверку на origin (как в chat_message)
            if (fileData) {
                setData(prevData => ({
                    ...prevData,
                    messages: prevData.messages.map(msg =>
                        msg.id === fileData.messageId
                            ? { ...msg, files: [...msg.files, fileData.file] }
                            : msg
                    )
                }));

                chatApi.readAllChatMessages(chat).then(() => {
                    scrollToBottom();
                    resetSupportUnreadCountIfNeeded();
                });
            }
        });

        chatApi.readAllChatMessages(chat);
        setTimeout(() => {
            scrollToBottom();
            resetSupportUnreadCountIfNeeded();
        }, 1000);

        return () => {
            websocket.send('leave_chat', { chatId: chat, origin: window.location.origin });
        };
    }, [chat]);

    const addMes = (chatId, message, parentMessageId, file) => {
        setSaving(true)
        setProgress(0)
        appendMessage(message, parentMessageId)

        chatApi.createMessage({
            chatId: chatId,
            message: JSON.stringify(message),
            parentMessageId: parentMessageId,
        }, {
            onUploadProgress: function(progressEvent) {
                let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

                // setProgress(percentCompleted)
            },
        }).then(async (res) => {
            setMessage('')
            setAnswerTo(null)
            setAnswerAuthor(null)

            if (res.status === 200) {
                if (file && typeof file === 'object') {
                    const formData = new FormData();
                    formData.append('file', file);

                    await chatApi.addMessageFile(res?.data.id, formData, {
                        onUploadProgress: function (progressEvent) {
                            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setProgress(percentCompleted)
                        },
                        cancelToken: source.token
                    }).then((res) => {
                        setIsVisiblePopup(false)
                        setAction(false)
                        setFile(null)
                    })
                }
            }
        }).finally(() => {
            chatApi
              .getChat(chat)
              .then((res) => setData(res?.data))

            setTimeout(() => {
                setSaving(false);
                setProgress(0);
            }, 1000)
        })
    }

    const appendMessage = (message, parentMessageId) => {
        setData({
            ...data,
            messages: [
                ...data.messages,
                {
                    id: 'new_' + (new Date()).getTime(),
                    author: data?.members?.find(member => member.user_id === profile.id)?.member_id,
                    message: `\"${message}\"`,
                    parentId: parentMessageId,
                    createdAt: (new Date()).getTime() / 1000,
                    files: []
                }
            ]
        })

        setTimeout(scrollToBottom, 50)
    }

    const clearAnswer = () => {
        setAnswerTo(null)
        setAnswerAuthor(null)
    }

    const handleCloseFilePopup = () => {
        if (saving) {
            source.cancel('Operation canceled by the user.');
        }

        setSaving(false)
        setIsVisiblePopup(false)
    }

    const onKeyDownHandler = (e) => {
        if (e.key === "Enter") {
            if (e.shiftKey || e.ctrlKey) {
                return;
            } 
            else if (message.trim()){
                e.preventDefault();
                addMes(data.id,message, answerTo?.id);
                setMessage('');
            }
            else{
                setMessage('');
            }
        }
    };

    const sendMessage = (e) => {
        e.preventDefault();
        if(message?.trim()){
            addMes(data.id,message, answerTo?.id);
            setMessage('');
        }
    }

    const [bindFile] = useInputNew({
        name: "file",
        value: file,
        onChange: (e) => setFile(e),
        placeholder: "",
    });

    const scrollToClip = () => {
        fixedRef.current.scrollIntoView({behavior: 'smooth'})
        fixedRef.current.style.background = '#EDE0FF'
        setTimeout( () => fixedRef.current.style.background = '#fff', 1000)
    }

    useEffect(() => {
        if (action) {
            addMes(data.id, message, answerTo?.id, file);
        }
    }, [action])

    const addFile = () => {
        setIsVisiblePopup(true)
    }
    const isCreator = data?.members?.filter(member => member.isCreator === 1)
    const creator = isCreator?.length === 1 ? isCreator[0].name : 'Вы'
    const fixedId = data?.fixedMessage?.id;
    const fixedMessage = fixedId ? data.messages.find((mess) => mess.id === fixedId) : null;

    const HEIGHT_DIFFER = 4;
    const SCROLL_HEIGHT = height/* - 200*/;

    const scrollToBottom = () => {
        messageEndRef?.current?.scrollIntoView({behavior: 'smooth'})
    }

    const getFromBottom = () => {
        if (answerTo) return  '136px'
        else  return '64px'
    }

    const onDeleteMessage = (message) => {
        setData({
            ...data,
            messages: data.messages?.filter(msg => msg.id !== message.id)
        })
    }

    const handleCollapseBtnClick = () => setPage('default')
    const goToMainPage = () => {
        if(data?.type === 'support' && isTechSupport){
            setPage('main', null, 'create', { selectedTab: 'support' })
        }
        else{
            setPage('main')
        }
    }
    const searchMention = async (text) => {

        try {
            const tagValue = text.match(/@(\S+)/)[1]
            const users = data?.members
                ?.filter(member => member.name.includes(tagValue))
                .map(member => ({
                    id: member.user_id,
                    name: member.name,
                    image: process.env.REACT_APP_PATH_FILE + member.avatar,
                }));

            return users;
        } catch (error) {
            console.error("Failed to search mentions:", error);
            return [];
        }
    };

    const { isTechSupport, chatIsDisabledButTechnicalSupportIsEnabled } = useIsTechSupport()

    const [isActiveMenuInHeader, setIsActiveMenuInHeader] = useState(false);

    const toggleMenuInHeader = (e) => {
        e.stopPropagation()
        setIsActiveMenuInHeader(prev => !prev)
    }

    const read = () => {
        chatApi.read(chat, {read: false}).then(({data})=>{
            if(data.status === 'success'){
                if(chatIsDisabledButTechnicalSupportIsEnabled && !isTechSupport){
                    setPage('default')
                }
                else{
                    goToMainPage()
                }
            }
        })
    }
    
    return (
        <div className={s.page} style={{height: `${height - HEIGHT_DIFFER}px`}}>
            <div className={s.header}>
                {
                    (isTechSupport || !chatIsDisabledButTechnicalSupportIsEnabled) && (
                        <button 
                            type={'button'} 
                            className={s.btn} 
                            onClick={goToMainPage}>
                                <ArrowLeftIcon/>
                        </button>
                    )
                } 
                
                {data?.members?.length > 2 ? <UserImage path={data?.avatar}/> : ''}
                <div className={s.title}>
                    {titleChat && (data?.type !== 'support' || !isTechSupport) && titleChat}
                    {
                        titleChat && data?.type === 'support' && isTechSupport && (
                            <span onClick={() => setEditChildren(idInterlocutor)}>{titleChat}</span>
                        )
                    }
                    {!titleChat && 'Чат'}
                    {data?.type !== 'support' && (
                        <div className={s.participants}>{data?.members?.length > 2 ? `${data?.members?.length} ${getRightWord(data?.members?.length, ['участник', 'участникa', 'участников'])}` : ''}</div>
                    )}
                </div>
                <div className={s.menuInHeaderWrapper}>
                    <div className={s.dots} onClick={(e) => toggleMenuInHeader(e)}><DotsIcon/></div>
                    <div 
                        className={classNames(s.menuInHeader, s.menu, {[s.active]: isActiveMenuInHeader})} 
                        onMouseLeave={() => setIsActiveMenuInHeader(false)}>
                        {
                            data?.members?.length !== 2 && (
                                <div onClick={() => setPage('info', chat)} className={s.menuInHeaderRow}>
                                    <div className={s.menuInHeaderName}>Участники чата</div>
                                </div>
                            )
                        }
                        <div className={s.menuInHeaderRow} onClick={read}>
                            <div className={s.menuInHeaderName}>Отметить непрочитанным</div>
                        </div>
                    </div>
                </div>
                <CollapseBtn onClick={handleCollapseBtnClick} />
            </div>
            {fixedMessage &&
                <FixedMessage
                    message={fixedMessage}
                    data={data}
                    customClass={s.clipMessage}
                    setIsNeedUpdate={setIsNeedUpdate}
                    scrollToClip={scrollToClip}
                />}
            <div className={classNames('new-design-scroll', s.messages)} style={{height: `${SCROLL_HEIGHT}px`}}>
                <div className={s.defaultMessage}>
                    {creator} создали {data?.name?.length > 0 ? data?.name : 'чат'}
                </div>
                {data?.messages && data?.messages.map((chat, index, array) => {
                    const previousDate = index > 0 ? array[index - 1]?.createdAt : null;
                    const currentDate = chat?.createdAt;

                    return <>
                        <NewMessagesDateView 
                            previousDate={previousDate} 
                            currentDate={currentDate} 
                        />
                        <ChatMessage
                            message={chat}
                            key={chat.id}
                            data={data}
                            setAnswer={setAnswerTo}
                            setAnswerAuthor={setAnswerAuthor}
                            activeUsers={activeUsers}
                            setIsNeedUpdate={setIsNeedUpdate}
                            fixed={data?.fixedMessage?.id}
                            fixedRef={fixedRef}
                            onDeleteMessage={onDeleteMessage}
                        />
                    </>
                })}
                <div className={s.messageEnd} ref={messageEndRef}></div>
            </div>
            <div className={s.footer}>
                {answerTo && answerAuthor && <div className={s.answerTo}>
                    <div className={s.answerToWrapper}>
                        <div className={s.answerName}>{answerAuthor.name}</div>
                        { 
                            (answerTo.message && containsHtmlTags(answerTo.message)) ? 
                            (<div dangerouslySetInnerHTML={{ __html: answerTo.message }} className={classNames(s.message, s.messageDz)} />) :
                            <div className={s.message} >
                                <MessageTextView 
                                    message={isJson(answerTo.message) ? JSON.parse(answerTo.message) : answerTo.message} 
                                />
                            </div>
                        }
                        <div className={s.close} onClick={clearAnswer}>
                            <CloseIcon width={'24'} height={'24'}/>
                        </div>
                    </div>
                </div>}
                <div className={s.footerForm}>
                    <form className={s.form} onSubmit={addMes} onKeyDown={onKeyDownHandler}>
                        <button type={'button'} className={s.clipBtn} onClick={addFile}>
                            <PaperClipIcon witdh={'32'} height={'32'}/>
                        </button>
                        {isActive && <div className={classNames(s.menu, isActive ? s.active : '')}>
                            <div className={s.menuRow}>
                                <div className={s.menuRowItem}>
                                    <InputNew.InputFileNewDesign
                                        className={s.inputFile}
                                        {...bindFile}
                                        newDesign
                                        isFileIcon
                                        placeholder='Файл'
                                        icon='file'
                                    />
                                </div>
                            </div>
                        </div>}
                        <InputEmoji
                            value={message}
                            onChange={setMessage}
                            placeholder={'Напишите сообщение'}
                            fontSize={14}
                            borderColor={'transparent'}
                            language={'ru'}
                            searchMention={searchMention}
                            cleanOnEnter={false}
                            shouldReturn={true}
                        />
                        
                        <button className={`${!message?.trim() ? s.noActiveSubmit : null} ${s.submit}`} onClick={sendMessage} type={'submit'}><img style={{width: '25px'}} src={sendIcon} alt="Отправить"/></button>
                        
                    </form>
                </div>
            </div>
            {isVisiblePopup && <Popup
                isVisiblePopup={isVisiblePopup}
                closeCallback={handleCloseFilePopup}
                header={'Выберите фото или файл'}
                updateFile={true}
                setAction={setAction}
                setFile={setFile}
                file={file}
                uploading={saving}
                progress={progress}
            />}
            {data?.messages?.length > 6 &&
                <button type={'button'} className={s.btnScroll} onClick={scrollToBottom} style={{bottom: `${getFromBottom()}`}}><ArrowLeftIcon/></button>}

            <EditEntityModal
                open={!!dataForEditEntityModal?.userId}
                {
                    ...dataForEditEntityModal
                }
                onDismiss={() => setEditChildren(null)} 
            />
        </div>
    )
}

const NewMessagesDateView = ({previousDate, currentDate}) => {
    // if(typeof previousDate !== 'string') return
    if(typeof currentDate !== 'string') return

    let isDifferent = false;
    let showingDateString = ""

    try {
        const previous = new Date(previousDate)
        const current = new Date(currentDate)

        isDifferent = !previous || current.toDateString() !== previous.toDateString()

        if(isDifferent){
            const date = createDate({date: current});
            showingDateString = `${date.dayNumber} ${date.monthGenitive}`;
        }
    } catch (error) {
        console.log(error)
    }
    
    if(isDifferent){
        return (
            <div className={s.newDayView}>
                <span>{showingDateString}</span>
            </div>
        )
    }        
}

export default InChatView;